<template>
  <div class="control">
    <h3 class="label">{{ parent.title }}</h3>
    <label class="caption trim text-base  block mb-3" :for="id">{{ label }}</label>
    <multiselect
      :id="id"
      v-model="selected"
      :clear-on-select="true"
      :close-on-select="false"
      :hide-selected="true"
      :internal-search="false"
      :limit-text="limitText"
      :limit="3"
      :loading="isLoading"
      :max-height="600"
      :multiple="true"
      :no-options="''"
      :options-limit="300"
      :options="options"
      :searchable="true"
      label="title"
      open-direction="bottom"
      placeholder="Type to search localities"
      track-by="title"
      @search-change="asyncFindCountry"
    >
      <template slot="tag" slot-scope="{ option, remove }">
        <span class="multiselect__tag">
          <span>{{ option.title }}</span>
          <span class="multiselect__remove" title="remove option" @click="remove(option)">×</span>
        </span>
      </template>
      <template slot="clear" slot-scope="props">
        <div
          v-if="selected.length"
          class="multiselect__clear"
          @mousedown.prevent.stop="clearAll(props.search)"
        ></div> </template
      ><span slot="noResult">No matches found</span>
      <span slot="noOptions">
        <template v-if="!query">
          Please enter a search query
        </template>
      </span>
    </multiselect>
  </div>
</template>
<script>
import Multiselect from "vue-multiselect";
import { ajaxFindLocality } from "./countriesApi";

export default {
  components: {
    Multiselect,
  },
  props: {
    parent: {
      type: Object,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    initialValue: {
      type: Array,
      default: () => [],
    },
    resource: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      query: "",
      minQueryLength: 1,
      selected: [],
      options: [],
      isLoading: false,
    };
  },
  computed: {
    id() {
      return `localities-${this.parent.id}`;
    },
  },
  watch: {
    selected(nowSelected) {
      this.$emit("change", nowSelected);
    },
  },
  created() {
    this.selected = [...this.initialValue];
  },
  methods: {
    limitText(count) {
      return `and ${count} other countries`;
    },
    async asyncFindCountry(query) {
      this.query = query;

      if (query.length >= this.minQueryLength) {
        this.isLoading = true;
        this.options = await ajaxFindLocality({
          query,
          url: this.resource,
          parentId: this.parent.id,
        });
        this.isLoading = false;
      }
    },
    clearAll() {
      this.selected = [];
    },
  },
};
</script>
